import React, { useEffect, useRef, useState } from 'react';
import Dependencies from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/dependencies/index.tsx';
import Footer from '../common/footer/index.tsx';
import Header from '../common/header/index.tsx';
import Legend from '../common/legend/index.tsx';
import { LegendToggleButton } from '../common/legend/toggle-button/view.tsx';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';

const dispatchWindowResizeEvent = () => {
	// Roadmap component tries to resize on resize event of window
	const resizeEvent = ((): Event => {
		if (typeof Event === 'function') {
			return new Event('resize');
		}

		// IE 11

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const event = document.createEvent('Event');
		event.initEvent('resize', true, true);
		return event;
	})();

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window.dispatchEvent(resizeEvent);
};

export const DependencyReportMacroView = () => {
	const [isLegendOpen, setIsLegendOpen] = useState(false);

	const isFirstRender = useRef<boolean>(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		dispatchWindowResizeEvent();
	}, [isLegendOpen]);

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div className={styles.container}>
			<Header />
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.main}>
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.dependencyReportContainer}>
					<Dependencies
						legendToggleButton={
							<LegendToggleButton isOpen={isLegendOpen} setIsOpen={setIsLegendOpen} />
						}
					/>
				</div>
				{isLegendOpen && (
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					<div className={styles.legend}>
						<Legend />
					</div>
				)}
			</div>
			<Footer />
		</div>
	);
};
